import { ArchiveData } from "@/components/Archive/Pages/DataGrid/Types";

import { DataAdapter } from "@/DataAdapter/DataAdapter";

export const fetchArchiveData = (procedureId: number | string) => {
	return DataAdapter.Get<ArchiveData>({
		endpoint: `archive/getGrid/${procedureId}`,
	});
};
